import { useQuery } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import CreditCardsRepository from 'src/features/creditCards/data/CreditCardsRepository';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { PaymentMethodSlug } from 'src/types/common';

const creditCardsRepository = diContainer.get<CreditCardsRepository>(
  CreditCardsRepository
);

interface UseCreditCardsParams {
  payment_method?: PaymentMethodSlug.Card | PaymentMethodSlug.OpenPay;
}

export default function useCreditCards({
  payment_method,
}: UseCreditCardsParams = {}) {
  const { user, session } = useAuthContext();
  const query = useQuery({
    queryKey: ['creditCards', user?.pk, payment_method],
    queryFn: () =>
      session &&
      user &&
      creditCardsRepository.getStoredUserCreditCards({
        userId: user?.pk,
        accessToken: session?.accessToken,
        payment_method,
      }),
    enabled: !!user && !!session,
  });

  return {
    cards: query.data?.results,
    mainCard: query.data?.results?.find((card) => card.is_main),
    ...query,
  };
}
